export default "__VITE_ASSET__D_59MFrN__"